import coachImage from "icons/tempCoachImage.png";
import {
  CoachImage,
  DeactivateIcon,
  EditPencil,
  LastActivityIcon,
  LastCapturedIcon,
  LeftHandedImage,
  LocationPinIcon,
  RightHandedImage,
  StrikerRole,
} from "icons";
import { PersonalDetailsForm } from "../personalDetailForm";
import { handednessId, ROLE, RoleId } from "utils/constants";
import { ConditionalRenderer } from "components";
import { useState } from "react";
import { AccountSettings } from "../accountSettings";
import { SubscriptionDetail } from "../subscriptionDetail";
import moment from "moment";
import { Avatar, Modal } from "antd";
import { DeactivateAccount } from "../deactivateAccount";
import { UserOutlined } from "@ant-design/icons";
import { getInitialLetters } from "utils/helpers";
import styles from "./styles.module.scss";

export const PersonalDetails = ({
  userDetails,
  address,
  getUsers,
  page,
  size,
  search,
  currentSubscription,
  currentSubscriptionLoading,
  currentSubscriptionRefetch,
  currentPlanObj,
  userDetailsRefetch,
}) => {
  // RightHandedImage, StrikerRole

  const [openDeactivateModal, setOpenDeactivateModal] = useState(false);
  const { firstName, lastName, email, roleId, playerTypeId } =
    userDetails || {};
  const tabsArrLocal = [
    {
      title: "Switch to Striker",
      key: "striker",
      icon: StrikerRole,
    },
    {
      title: "Coach",
      key: "coach",
      icon: coachImage,
    },
  ];

  const [activeTab, setActiveTab] = useState(tabsArrLocal[0].key);

  function closeModal() {
    setOpenDeactivateModal(false);
  }
  const keysFordeactivation = {
    deActivate: "Deactivate",
    deActivating: "deactivating",
    deActivation: "Deactivation",
    payloadAndApiKey: "blockUser",
  };
  const keysForActivation = {
    deActivate: "Activate",
    deActivating: "activating",
    deActivation: "Activation",
    payloadAndApiKey: "unBlockUser",
  };
  const activationKeys = userDetails?.active
    ? keysFordeactivation
    : keysForActivation;

  const isCoachLinked = false;

  return (
    <div className={styles.personal}>
      <div className={styles.nameAndRole}>
        <h2 className={styles.heading}>Personal Details</h2>
        <div
          className={styles.deactivate}
          onClick={() => setOpenDeactivateModal(true)}
        >
          <DeactivateIcon /> {activationKeys.deActivate} Account
        </div>
      </div>

      <div className={styles.personalBody}>
        <div className={styles.personalInfo}>
          <div className={styles.DP}>
            <label
              htmlFor="file"
              style={{ cursor: "pointer", position: "relative" }}
            >
              <ConditionalRenderer condition={userDetails?.picture}>
                <div className={styles.image}>
                  <Avatar
                    size={75}
                    src={userDetails?.picture}
                    alt=""
                    icon={!userDetails?.picture && <UserOutlined />}
                  />
                </div>
              </ConditionalRenderer>
              <ConditionalRenderer
                condition={
                  (userDetails?.firstName || userDetails?.lastName) &&
                  !userDetails?.picture
                }
              >
                <div
                  className={styles.imageInitials}
                  style={{ backgroundColor: "#7E8B9F", fontWeight: "bold" }}
                >
                  {getInitialLetters(
                    `${userDetails?.firstName} ${userDetails?.lastName}`
                  )}
                </div>
              </ConditionalRenderer>
              <div className={styles.editIcon}>
                <EditPencil />
              </div>
              <input type="file" id="file" style={{ display: "none" }} />
            </label>
            <div className={styles.profileContainer}>
              <div className={styles.name}>
                {firstName} {lastName}
              </div>
              <div
                className={styles.handedness}
                style={{ backgroundColor: "#c7e7ff" }}
              >
                {RoleId[roleId] === ROLE.Striker ? (
                  <StrikerRole height={15} width={15} />
                ) : (
                  <CoachImage height={17} width={17} />
                )}
                <span> {RoleId[roleId]} </span>
              </div>
              <div
                className={styles.handedness}
                style={{ backgroundColor: "#16A6654D" }}
              >
                {handednessId[playerTypeId] === "Left Handed" ? (
                  <LeftHandedImage />
                ) : (
                  <RightHandedImage />
                )}
                <span>{handednessId[playerTypeId]}</span>
              </div>
            </div>
          </div>
          <div className={styles.location}>
            <ConditionalRenderer condition={address?.country}>
              <LocationPinIcon />
              {address?.city}, {address?.country}
            </ConditionalRenderer>
            {/* <SwitzerlandIcon /> */}
            <ConditionalRenderer condition={address?.countryImage}>
              <img
                src={address?.countryImage}
                alt="countryImage"
                height={24}
                width={24}
              />
            </ConditionalRenderer>
          </div>
          <ConditionalRenderer
            condition={RoleId[roleId] === ROLE.Striker && isCoachLinked}
            // condition={true}
          >
            <div className={styles.coachDeatils}>
              <div className={styles.image}>
                <img src={coachImage} alt="" />
              </div>
              <div className={styles.nameAndEmail}>
                <div className={styles.name}>
                  Albert Alexander <span>(Coach)</span>
                </div>
                <span className={styles.email}>vava@gmail.com</span>
              </div>
            </div>
          </ConditionalRenderer>
        </div>

        <div className={styles.dates}>
          <div>
            <LastCapturedIcon />{" "}
            <span>
              Last Captured:
              {userDetails?.lastCaptured &&
                moment(userDetails?.lastCaptured).format("LL")}
            </span>
          </div>
          <div>
            <LastActivityIcon />{" "}
            <span>
              Last Activity:
              {userDetails?.lastActivity &&
                moment(userDetails?.lastActivity).format("LL")}
            </span>
          </div>
        </div>

        <PersonalDetailsForm
          userDetails={userDetails}
          address={address}
          getUsers={getUsers}
          page={page}
          size={size}
          search={search}
        />
        <ConditionalRenderer condition={activeTab === "security"}>
          <AccountSettings userDetails={userDetails} />
        </ConditionalRenderer>
        <ConditionalRenderer condition={activeTab === "subscription"}>
          <SubscriptionDetail
            userID={userDetails?.id}
            currentSubscription={currentSubscription}
            currentSubscriptionLoading={currentSubscriptionLoading}
            currentSubscriptionRefetch={currentSubscriptionRefetch}
            currentPlanObj={currentPlanObj}
          />
        </ConditionalRenderer>
      </div>
      <Modal
        title={`${activationKeys.deActivate} Account`}
        open={openDeactivateModal}
        footer={null}
        onCancel={closeModal}
        width="614px"
        centered
      >
        <DeactivateAccount
          closeModal={closeModal}
          email={email}
          userDetailsRefetch={userDetailsRefetch}
          isActive={userDetails?.active}
          activationKeys={activationKeys}
        />
      </Modal>
    </div>
  );
};
